var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-card-group',{class:['ts-card-collection', 'ts-hand']},_vm._l((_vm.cards),function(card){return _c('TSCard',{key:card.number,attrs:{"card":card,"display":"full"}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }